import { render, staticRenderFns } from "./WeeklySchedule.vue?vue&type=template&id=0fa74aba&scoped=true&"
import script from "./WeeklySchedule.vue?vue&type=script&lang=js&"
export * from "./WeeklySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa74aba",
  null
  
)

export default component.exports